import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sourceDevice'
})
export class SourceDevicePipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    const created = args[0];
    return value === 'WEBSITE' ? 'Web' : created ? 'Shape' : 'Smartphone';
  }

}
